export default (axios) => ({
    getAll: (params) => axios.get('u/recruitments?origin=benhvien16a.com', { params }).then((_) => _.data),
});
